"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.languageProficiencyMap = void 0;
exports.languageProficiencyMap = {
    ELEMENTARY: 'Elementary',
    LIMITED_WORKING: 'Limited working',
    PROFESSIONAL_WORKING: 'Professional working',
    FULL_PROFESSIONAL: 'Full professional',
    NATIVE_OR_BILINGUAL: 'Native or bilingual',
};
